import React, { Fragment } from 'react'
import Row from './Row'

function Rows(props) {
  return (
    <Fragment>
    {
      props.rows.map((cols, index) => {
        return (
          <Row cols={cols} key={index} />
        )
      })
    }
    </Fragment>
  )
}

export default Rows